function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContainerStacked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9 10a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1H10a1 1 0 0 1-1-1V10zm12 0H10v6h11v-6zm0 7H10v6h11v-6zm-9-2.5v-3h1v3h-1zm3 0v-3h1v3h-1zm3 0v-3h1v3h-1zm-6 7v-3h1v3h-1zm3 0v-3h1v3h-1zm3 0v-3h1v3h-1z",
    clipRule: "evenodd",
    style: {
      fill: "#00243d"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContainerStacked);
export default __webpack_public_path__ + "static/media/container-stacked.ae1ff052478c94e1055f51249147e2a5.svg";
export { ForwardRef as ReactComponent };